import React from 'react';
import { MenuSelect } from '../';

const families = [{ label: 'Helvetica'}, { label: 'Courier'}, {label: 'Garamond'}, {label: 'Palatino'}, {label: 'Times New Roman'}];
const sizes = [{label: '8'}, {label: '10'}, {label: '12'}, {label: '13'}, {label: '14'}, {label: '16'}, {label: '20'},{ label: '28'}, {label: '36'}, {label: '48'}, {label: '64'}];

interface IFontProps {
  fontFamily: string,
  fontOptions?: object,
  fontSize: string,
  onFamilyClick: (fontName: string) => void,
  onSizeClick: (size: string) => void,
}

export const Font: React.FunctionComponent<IFontProps> = ({ fontFamily, fontOptions, fontSize, onFamilyClick, onSizeClick}) => {
	if (!fontOptions) { return (<span />); }
	return (
		<span>
			<MenuSelect needsCiq={false} options={sizes} keyName="family" handleOptionSelect={onSizeClick} menuId="fontSizeSelect" title={fontSize} />
			<MenuSelect needsCiq={false} options={families} keyName="size" handleOptionSelect={onFamilyClick} menuId="fontFamilySelect" title={fontFamily} />
		</span>
	);
};